/**
 * Created by andrey on 09.02.2021.
 */

Map2dDecorator.prototype.updateDecorator = function () {

};

Map2dDecorator.prototype.updateLargeBox = function () {

};

Map2dDecorator.prototype.updateParent = function () {

};

Map2dDecorator.prototype.getDecoratorHash = function () {
    return cleverapps.hashCode(`${this.code}|${this.x || 0}|${this.y || 0}|${this.dx || 0}|${this.dy || 0}|${this.rotation || 0}|${this.scaleX || 1}|${this.scaleY || 1}`);
};

Map2dDecorator.prototype.createView = cleverapps.extendFunc(Map2dDecorator.prototype.createView, function () {
    const view = this._super();

    if (this.updateLargeBox) {
        this.updateLargeBox();
    }

    return view;
});

Map2dDecorator.prototype.getSaveInfo = function () {
    return {
        code: this.code,
        x: this.x,
        y: this.y,
        dx: this.dx || 0,
        dy: this.dy || 0,
        rotation: this.rotation || 0,
        scaleX: this.scaleX || 1,
        scaleY: this.scaleY || 1,
        largeBox: this.largeBox
    };
};

Map2dDecorator.prototype.setLargeBox = function (largeBox) {
    const oldLarge = this.isLarge();

    this.largeBox = largeBox;

    if (oldLarge === this.isLarge()) {
        return;
    }

    const largeDecorators = Map2d.currentMap.decorators.largeDecorators;

    if (this.isLarge()) {
        largeDecorators.push(this);
    } else {
        cc.arrayRemoveObject(largeDecorators, this);
    }
};

Map2dDecorator.prototype.getViewClass = cleverapps.extendFunc(Map2dDecorator.prototype.getViewClass, function () {
    if (cleverapps.config.editorMode) {
        return EditorMap2dDecoratorView;
    }
    // eslint-disable-next-line prefer-spread,prefer-rest-params
    return this._super.apply(this, arguments);
});

Map2dDecorator.prototype.highlight = function (options) {
    options = options || {};

    this.unhighlight();

    this.light = new Highlight(this.x, this.y, {
        isErrorLight: options.isErrorLight,
        unit: this,
        drag: options.drag
    });

    if (options.drag) {
        Map2d.currentMap.onAnimationsAdd(this.light);
        this.light.move(this.x, this.y, true);
    }
};

Map2dDecorator.prototype.unhighlight = function () {
    if (this.light) {
        this.light.remove();
        delete this.light;
    }
};

Map2dDecorator.prototype.getShape = function () {
    return FamiliesHelper.ShapeCell;
};

Map2dDecorator.prototype.canMoveTo = function () {
    return true;
};
